var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "volume-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.03,
    height: 19.895,
    viewBox: "0 0 26.03 19.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "volume-up-2",
    "data-name": "volume-up",
    d: "M13.136,3.066a1.548,1.548,0,0,0-.823.374h0L7.183,8H3.5A2.516,2.516,0,0,0,1,10.5v5.006a2.516,2.516,0,0,0,2.5,2.5h3.68l5.129,4.559A1.557,1.557,0,0,0,14.9,21.407V4.6a1.581,1.581,0,0,0-.919-1.421A3.066,3.066,0,0,0,13.136,3.066Zm.1,1.786V21.159L8.054,16.553a.835.835,0,0,0-.554-.211h-4a.822.822,0,0,1-.834-.834V10.5A.822.822,0,0,1,3.5,9.668h4a.834.834,0,0,0,.554-.211Z",
    transform: "translate(-1 -3.065)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19762",
    "data-name": "Group 19762",
    transform: "translate(5 5.451)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    x2: 6,
    y2: 6,
    transform: "translate(13.969 1.497)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    x1: 6,
    y2: 6,
    transform: "translate(13.969 1.497)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.b04e1982b42a0df3f3b46825b920b285.svg";
export { ForwardRef as ReactComponent };